<template>
  <div class="pa-4">
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-list-item
            class="pa-0 pl-2 ma-0"
            dense
            style="height:40px;background-color: var(--v-background-base);border:solid 1px var(--v-bordercolor-base);"
            v-bind="attrs"
            v-on="on"
        >
          <v-list-item-title>{{ menuItems[currentTab].name }}</v-list-item-title>

          <div
              style="height:40px;width:16px;background-color: var(--v-secondary-base);display: flex;align-items: center;justify-content: center;"
          >
            <v-img
                max-height="5px"
                max-width="8px"
                src="../assets/puldown_arrow.png"
            />
          </div>
        </v-list-item>
      </template>
      <v-list :style="`overflow-y: auto;max-height: ${$vuetify.breakpoint.height-300}px`">
        <v-list-item
            v-for="(item,index) in menuItems.filter((element)=>element.name!='資料')"
            :key="index"
            @click="selectTab(index)"
        >
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-title style="color: var(--v-accent-base)">
              資料
            </v-list-item-title>
          </template>
          <v-list-item
              v-for="(item) in documents"
              :key="item.id"
              @click="selectDocument(item)"
          >
            <v-list-item-title>{{ item.name && item.name.length != 0 ? item.name : 'タイトル無し' }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-menu>

    <div
        :style="`background-color: var(--v-background2-base);height:${hideAppbar ? $vuetify.breakpoint.height-220 :$vuetify.breakpoint.height-400}px`"
        class="mini-content-area my-4 px-4 py-4"
    >
      <div v-if="currentTab==0">
        <div
            class="document-content"
            v-html="preview"
        />
      </div>
      <div v-if="currentTab==1">
        <p   class="ma-0 px-2 py-1"
               style="max-width:100%;border-radius: 4px;background-color:  var(--v-bordercolor-base);font-size:11px;">
          編集履歴は5分ごとに小説を保存するたびに保存されます。<br>最大で小説ごとに50件まで保存されますが、アプリにこの履歴データは同期できないのでご注意ください。
        </p>
        <v-btn @click="getHistoryList()" small
               color="secondary"
               elevation="0"
               class="mt-2"
               width="100%"
               tile>
          <v-icon style="margin-right: 10px;">mdi-sync</v-icon>
          最新状態に更新
        </v-btn>
        <v-list class="ma-0 pa-0 mt-2">
          <v-list-item
              v-for="(item,index) in currentHistoryList"
              :key="item.id"
              style="border-bottom: 1px solid var(--v-bordercolor-base); "
              class="pa-0 ma-0"
              dense
          >
            <v-list-item-group style="width: 100%;">
              <div style="width: 100%;" class="mt-1">
                <div
                    class="document-content"
                >
                  保存日時：{{ item.modifiedTimestamp |dayjs }}
                </div>
              </div>
              <div style="text-align: right;width: 100%;" class="ma-0 pt-0 pb-0">
                <v-spacer/>
                <v-btn class="mr-1" x-small tile outlined color="secondary"
                       v-if="index!= currentHistoryList.length-1"
                       @click="openHistoryTarget(currentHistoryList[index+1],item)">1つ前と比較
                </v-btn>
                <v-btn x-small tile outlined color="secondary"
                       @click="openHistoryCurrent(item)">
                  現在と比較
                </v-btn>

                <v-btn icon @click="deleteItemData = item ; deleteDialog = true">
                  <DeleteIcon style="width: 20px;height: 25px;"/>
                </v-btn>
              </div>

              <div class="ma-0 pt-0 pb-0 mb-2">
                <v-btn small tile outlined color="secondary"
                       width="100%"
                       @click="doApplyHistory(item)">
                  このバージョンを適用
                </v-btn>
              </div>
            </v-list-item-group>

          </v-list-item>

        </v-list>
      </div>
      <div v-if="currentTab==2">
        <v-list class="ma-0 pa-0">
          <v-list-item
              v-for="(item) in plots"
              :key="item.id"
              class="pa-0 ma-0"
              dense


          >
            <div
                :style="item.content.length!=0 ? `margin-bottom:8px`:`font-weight:bold;`"
                class="document-content"
            >
              {{ item.name }}{{ item.content }}

            </div>
          </v-list-item>
        </v-list>
      </div>
      <div v-if="currentTab==3">
        <v-list class="ma-0 pa-0">
          <v-list-item
              v-for="(item) in themes"
              :key="item.id"
              class="pa-0 ma-0"
              dense
          >
            <div
                class="document-content"
                style="margin-bottom: 8px"
            >
              <p
                  class="ma-0 pa-0"
                  style="font-weight: bold"
              >
                {{ item.name }}
              </p>
              <p class="ma-0 pa-0">
                {{ item.content }}
              </p>
            </div>
          </v-list-item>
        </v-list>
      </div>
      <div v-if="currentTab==4">
        <div
            class="document-content"
            style="margin-bottom: 8px"
        >
          <p
              class="ma-0 pa-0"
              style="font-weight: bold"
          >
            {{ currentDocument.name }}
          </p>
          <HorizontalScroll style="width: 100%;">
            <div
                v-for="(img, index) in documentImages"
                :key="img.url"
                class="mr-4 image-document "
            >
              <v-img
                  :src="img.src"
                  aspect-ratio="1"
                  height="128"
                  width="128"
                  @click="openGallery(index)"
              />
            </div>
          </HorizontalScroll>
          <p
              class="ma-0 pa-0"
              v-html="currentDocument.content "
          >
            <!--            {{ currentDocument.content }}-->
          </p>
        </div>
      </div>
    </div>
    <LightBox
        ref="lightbox"
        :media="documentImages"
        :show-caption="false"
        :show-light-box="false"
    />
    <v-dialog
        v-model="deleteDialog"
        max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          削除確認
        </v-card-title>
        <v-card-text v-if="deleteItemData!=null">
          指定の本文履歴を削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              color="green darken-1"
              text
              @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              @click="deleteItem(deleteItemData)"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="textDiffDialog"
        fullscreen
    >
      <v-card>
        <v-toolbar
            dark
            color="primary"
        >
          <v-btn
              icon
              dark
              @click="textDiffDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>編集履歴比較</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <TextDiff
            v-if="textDiff1"
            :diffs="{textDiff1:textDiff1,textDiff2:textDiff2}"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from '@/const'
import firebase from "firebase/app";
import axios from "axios";
import HorizontalScroll from "vue-horizontal-scroll"
import LightBox from 'vue-image-lightbox'
import {mapState} from "vuex";
import rubiConverter from "@/component/rubiConverter";
import dayjs from "dayjs";
import DeleteIcon from "@/component/svg/DeleteIcon";
import TextDiff from "@/component/TextDiff.vue";

export default {
  name: "MiniDocumentArea",
  components: {
    LightBox,
    DeleteIcon,
    HorizontalScroll,
    TextDiff
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    }
  },
  props: ["inputTitle", "inputText", "siteType","applyHistory"],
  data() {
    return {
      currentTab: 0,
      menu: false,
      menuItems: config.MINI_DOCUMENT_AREA_TABS,
      preview: null,
      plots: null,
      themes: null,
      documents: null,
      documentImages: [],
      currentDocument: null,
      currentHistoryList: null,
      deleteDialog: false,
      deleteItemData: null,
      textDiffDialog: false,
      textDiff1: null,
      textDiff2: null
    }
  },
  computed: {
    ...mapState({
      hideAppbar: state => state.userModule.hideTopBottomMode
    })
  },
  watch: {
    currentTab: {
      handler() {
        if (this.currentTab == 0) {
          this.formatPreview()
        }
        if (this.currentTab == 2 && this.plots == null) {
          this.getPlots()
        }
        if (this.currentTab == 3 && this.themes == null) {
          this.geThemes()
        }
        if (this.currentTab == 1) {
          this.getHistoryList()
        }
      }, immediate: true
    },
    inputText: {
      handler() {
        if (this.currentTab == 0) {
          this.formatPreview()
        }
      }, immediate: true
    }
  },
  async mounted() {
    const ret = await this.getApiData("auth/files", {
      "novelId": config.HASH_IDS.decode(this.$route.params.novelid)[0]
    })

    this.documents = ret.data.filter((element) => {
      return (element.name && element.name.length != 0) || (element.content && element.content.length != 0) || (element.photo != null && element.photo.length != 0)
    })
  },
  methods: {
    openHistoryCurrent(item) {
      this.textDiff1 = item
      this.textDiff1.versionName = `${this.$options.filters.dayjs(item.modifiedTimestamp)}のバージョン`
      this.textDiff2 = {
        name: this.inputTitle,
        content: this.inputText,
        versionName: "現在のバージョン"
      }
      this.textDiffDialog = true
    },
    doApplyHistory(item){
      this.applyHistory(item)
    },
    openHistoryTarget(item, target) {
      this.textDiff1 = item
      this.textDiff2 = target
      this.textDiff1.versionName = `${this.$options.filters.dayjs(item.modifiedTimestamp)}のバージョン`
      this.textDiff2.versionName = `${this.$options.filters.dayjs(target.modifiedTimestamp)}のバージョン`
      this.textDiffDialog = true
    },
    encodeHash: function (id) {
      return config.HASH_IDS.encode(id)
    },
    selectTab(tab) {
      this.currentTab = tab
      this.menu = false;
    },
    async getApiData(path, params) {
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      return await axios.get(config.API_URL + path, {
        headers: {"X-Firebase-Auth": token},
        params: params,
        data: {}
      })
    },
    formatPreview() {
      if (this.siteType.value == 7) {
        this.preview = this.inputText.replaceAll("\n", "<br/>")
      } else this.preview = rubiConverter.previewRubiConvert(this.escape_html(this.inputText))

    },
    escape_html(string) {
      if (typeof string !== 'string') {
        return string;
      }
      return string.replace(/[&'`"<>]/g, function (match) {
        return {
          '&': '&amp;',
          "'": '&#x27;',
          '`': '&#x60;',
          '"': '&quot;',
          '<': '&lt;',
          '>': '&gt;',
        }[match]
      });
    },
    async deleteItem(item) {
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      const ret = await axios.delete(config.API_URL + "auth/pagehistory/" + item.id, {
        headers: {"X-Firebase-Auth": token},
        data: {}
      })
      this.deleteDialog = false
      this.getHistoryList()
    },
    async getHistoryList() {
      const ret = await this.getApiData("auth/pagehistory", {
        pageid: config.HASH_IDS.decode(this.$route.params.text_id)[0]
      })
      this.currentHistoryList = ret.data.sort((a, b) => {
        if (a.modifiedTimestamp < b.modifiedTimestamp) return 1;
        if (a.modifiedTimestamp > b.modifiedTimestamp) return -1;
        return 0;
      })
    },
    async getPlots() {
      const ret = await this.getApiData("auth/plots", {
        "novelId": config.HASH_IDS.decode(this.$route.params.novelid)[0]
      })
      this.plots = ret.data.sort((a, b) => {
        if (a.orderIndex < b.orderIndex) return -1;
        if (a.orderIndex > b.orderIndex) return 1;
        return 0;
      }).filter((element) => {
        return element.name.length != 0 || element.content.length != 0
      })
    },
    async geThemes() {
      const ret = await this.getApiData("auth/themes", {
        "novelId": config.HASH_IDS.decode(this.$route.params.novelid)[0]
      })
      this.themes = ret.data.sort((a, b) => {
        if (a.orderIndex < b.orderIndex) return -1;
        if (a.orderIndex > b.orderIndex) return 1;
        return 0;
      }).filter((element) => {
        return element.name.length != 0 || element.content.length != 0
      })
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
    async selectDocument(document) {
      this.selectTab(4)
      const splitedPhoto = document.photo != null ? document.photo.split(",") : []
      document.content = document.content.replaceAll("\n", "</br>")
      this.currentDocument = document

      this.documentImages = [];
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }

      const images = await this.getApiData(`auth/file/${document.id}/photos`, {});
      this.documentImages = images.data.map((image) => {
        return {
          src: image.path,
          thumb: image.path,
          caption: '',
        }
      });
    }
  }

}
</script>

<style scoped>
.document-content {
  font-size: 13px !important;
  line-height: 1.8em;
  color: var(--v-textcolor-base) !important;
}

.image-document {
  border: solid 1px var(--v-bordercolor-base);
  background-color: var(--v-background2-base);
  width: 128px;
  height: 128px;
}

.mini-content-area {
  overflow-y: auto;
}

</style>
